/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import { useHistory, useLocation } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import {
  CircularProgress,
  Divider,
  Paper,
  Step,
  StepLabel,
  Stepper,
} from '@material-ui/core'

import { Container, ContentHeader } from 'components'
import Steps from './components/Steps'
import useContract from 'hooks/useContract'
import useCollapse from 'hooks/useCollapse'
import { useFetch } from '@yapay/react-components/hooks'
import * as service from 'service'
import constants from '../../constants'
import styles from './styles'

export const useStyles = makeStyles(styles)

const ContractsNew = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const { activeStep, setData } = useContract()
  const collapse = useCollapse()

  const {
    response: responseGenerateNfeOnInvoiceCreation,
    isLoading: isLoadingGenerateNfeOnInvoiceCreation,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_NFE_ON_INVOICE_CREATION,
  })

  const {
    response: responseInvoiceInterval,
    isLoading: isLoadingInvoiceInterval,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.INVOICE_INTERVAL,
  })

  const {
    response: responseDaysToGenerateNFe,
    isLoading: isLoadingDaysToGenerateNFe,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.DAYS_TO_GENERATE_NFE,
  })

  React.useEffect(() => {
    if (
      isLoadingInvoiceInterval ||
      isLoadingDaysToGenerateNFe ||
      isLoadingGenerateNfeOnInvoiceCreation
    )
      return

    const generalSettings = {
      generateNfeOnInvoiceCreation: Number(
        responseGenerateNfeOnInvoiceCreation?.data?.setting?.value,
      ),
      invoiceInterval: responseInvoiceInterval?.data?.setting?.value,
      daysToGenerateNfe: responseDaysToGenerateNFe?.data?.setting?.value,
    }

    setData(data => ({ ...data, generalSettings }))
  }, [
    isLoadingGenerateNfeOnInvoiceCreation,
    isLoadingInvoiceInterval,
    isLoadingDaysToGenerateNFe,
  ])

  React.useEffect(() => {
    if (!location.state) {
      return
    }

    if (location.state.contract) {
      setData(data => ({ ...data, ...location.state.contract }))
    }

    if (location.state.collapse) {
      collapse.setData(data => [...data, ...location.state.collapse])
    }

    history.replace({ pathname: location.pathname, state: null }) // clear state after save
  }, [location.state, setData])

  return (
    <div className={classes.root}>
      {isLoadingGenerateNfeOnInvoiceCreation ||
      isLoadingInvoiceInterval ||
      isLoadingDaysToGenerateNFe ? (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      ) : (
        <Container>
          <ContentHeader title="Assinatura" subtitle="Nova" />
          <Paper>
            <Stepper className={classes.stepper} activeStep={activeStep}>
              <Step>
                <StepLabel>Selecione um cliente</StepLabel>
              </Step>
              <Step>
                <StepLabel>Configure a assinatura</StepLabel>
              </Step>
              <Step>
                <StepLabel>Incluir impostos (opcional)</StepLabel>
              </Step>
              <Step>
                <StepLabel>Selecione um plano</StepLabel>
              </Step>
              <Step>
                <StepLabel>Revisão e Finalização</StepLabel>
              </Step>
            </Stepper>

            <Divider />

            {activeStep === 0 && <Steps.Client />}
            {activeStep === 1 && <Steps.Contract />}
            {activeStep === 2 && <Steps.Tax />}
            {activeStep === 3 && <Steps.Plan />}
            {activeStep === 4 && <Steps.Summary />}
            {activeStep === 5 && <Steps.Finish />}
          </Paper>
        </Container>
      )}
    </div>
  )
}

export default ContractsNew
